export default "__VITE_ASSET__b884894d__"